/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Group from 'components/form/Group';
import Title from 'components/Title';
import Dropdown from 'components/Dropdown';
import recommendations from 'common/choices/recommendations';
import withTargetRecommendations from '../withTargetRecommendations';
import LODEOMCIF from './LODEOMCIF';
import SCPI from './SCPI';

const summaries = {
    LODEOMCIF,
    SCPIRendement: SCPI,
    SCPIaCredit: SCPI,
    SCPIDemembreeCIF: SCPI,
};

const Recommendations = ({ recommendationCif }) => (
    <Group>
        <Title>
            <b>Recommandations soumises</b>
        </Title>

        {recommendationCif.map(({ type, ...recommendation }) => {
            const Summary = summaries[type];

            return (
                <Dropdown
                    key={type}
                    title={recommendations[type].title}
                    active
                >
                    {Summary && <Summary type={type} recommendation={recommendation} />}
                </Dropdown>
            );
        })}
    </Group>
);

Recommendations.propTypes = {
    recommendationCif: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
    })).isRequired,
};

export default withTargetRecommendations(Recommendations);
